import React from 'react';
import classes from './SideModal.module.scss';

export interface GridSize {
  xs: string;
  sm: string;
  md: string;
  lg: string;
  xl: string;
  xxl: string;
}

interface Alignment {
  horizontal: 'left' | 'right';
}

interface SideModalProps {
  title: React.ReactElement | string;
  onClose: () => void;
  breakPoint?: keyof GridSize | number;
  lined?: boolean;
  align?: Alignment['horizontal'];
  children?: React.ReactElement;
  className?: string;
}

const breakPointArray: GridSize = {
  xs: '350px',
  sm: '500px',
  md: '768px',
  lg: '992px',
  xl: '1200px',
  xxl: '1400px',
};

export const SideModal: React.FC<SideModalProps> = ({ title, onClose, breakPoint = undefined, lined = undefined, align = undefined, children = undefined, className = undefined }) => {
  let width = breakPointArray.sm;
  if (breakPoint) {
    if (typeof breakPoint === 'string') {
      width = breakPointArray[breakPoint];
    } else {
      width = `${breakPoint}px`;
    }
  }
  let alignment = classes['right-aligned'];
  if (align) {
    alignment = align === 'left' ? classes['left-aligned'] : classes['right-aligned'];
  }

  return (
    <div className={`${classes.sidebar} ${alignment} ${className}`} style={{ width }}>
      <div
        className={`${classes.sideHeader} ${lined === false ? '' : classes.lined
          }`}
      >
        <span className={`${typeof title === 'string' ? 'fw-bold' : ''}`}>
          {title}
        </span>
        <button type="button" onClick={onClose} className={classes.close} data-testid="sidebar-close" aria-label="sidebar-close">
          <svg
            width="21"
            height="20"
            viewBox="0 0 21 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={classes.closeImg}
          >
            <path
              d="M20.8868 2.00363L18.8832 0L10.8906 7.99637L2.89425 0.00381615L0.890625 2.00744L8.887 10L0.894441 17.9964L2.89807 20L10.8906 12.0036L18.887 20L20.8906 17.9964L12.8942 10L20.8868 2.00363Z"
              fill="black"
            />
          </svg>
        </button>
      </div>
      {children}
    </div>
  );
};
